import React from "react";
import "./Backdrop.css";

const backdrop = ({ children, position, hide, style, className }) => (
  <div
    className={`Backdrop ${className}`}
    style={{ ...style, position }}
    onClick={hide}
  >
    {children}
  </div>
);

export default backdrop;
